import type { SVGProps } from "react";

export function MistralLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      {/* Geometric M — 5 stacked horizontal bars */}
      <rect x="3" y="4" width="18" height="2.4" />
      <rect x="3" y="8.5" width="18" height="2.4" />
      <rect x="3" y="13" width="18" height="2.4" />
      <rect x="3" y="17.6" width="18" height="2.4" />
      {/* vertical accents to suggest M */}
      <rect x="3" y="4" width="3" height="16" />
      <rect x="18" y="4" width="3" height="16" />
      <rect x="10.5" y="8.5" width="3" height="11.5" />
    </svg>
  );
}
